import React from 'react'
import { SingleStatCard } from '../../Elements/Cards'
import { SkeletonLoader } from '../../Elements/Indicators'
import { EpicStatsProps } from '../../../types/epic-types'

/**
 * EpicStats component displays analysis summary statistics
 * Shows total epic count, analyzed count, and completion percentage
 */
export const EpicStats: React.FC<EpicStatsProps> = ({
  totalEpics,
  analyzedEpics,
  analysisPercentage,
  loading = false
}) => {
  // Show loading state with skeleton placeholders
  if (loading) {
    return (
      <div className="h-full">
        <dl className="grid grid-cols-1 gap-5 sm:grid-cols-3 h-full">
          <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt className="truncate text-sm font-medium text-gray-500">Total Epics</dt>
            <dd className="mt-1">
              <SkeletonLoader lines={1} height="h-8" className="w-16" />
            </dd>
          </div>
          <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt className="truncate text-sm font-medium text-gray-500">Analyzed</dt>
            <dd className="mt-1">
              <SkeletonLoader lines={1} height="h-8" className="w-16" />
            </dd>
          </div>
          <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt className="truncate text-sm font-medium text-gray-500">Analysis Complete</dt>
            <dd className="mt-1">
              <SkeletonLoader lines={1} height="h-8" className="w-16" />
            </dd>
          </div>
        </dl>
      </div>
    )
  }

  // Format percentage with % symbol
  const formattedPercentage = `${analysisPercentage}%`

  return (
    <div className="h-full">
      <dl className="grid grid-cols-1 gap-5 sm:grid-cols-3 h-full">
        <SingleStatCard
          stat={totalEpics}
          label="Total Epics"
        />
        <SingleStatCard
          stat={analyzedEpics}
          label="Analyzed"
        />
        <SingleStatCard
          stat={formattedPercentage}
          label="Analysis Complete"
        />
      </dl>
    </div>
  )
}